import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" {...props}>
    <path
      className="star_svg__path1"
      d="m12.633 19.484-7.388 3.884 1.411-8.226L.679 9.316l8.26-1.2L12.633.631l3.694 7.485 8.26 1.2-5.977 5.826 1.411 8.226z"
    />
  </svg>
);
const Memo = memo(SvgStar);
export default Memo;
